// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"135":"456a3e54","254":"7c59b0fb","577":"413b30fa","761":"4a1d99a0"}[chunkId] + ".chunk.js";
};